<template>
    <div class="managed-devices">
        <h1>Managed devices</h1>
    </div>
</template>

<script>
/**
 * Renderer for the landing page of the application
 */
export default {
    name: "managed-devices",
};
</script>
<style scoped lang="scss"></style>
